import React from "react";
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import mainLogo from './../_img/logo-csmile.png';
import { GetCorService, INSCorServicePostTest } from '../_getjson';
require('./../_css/PopUpOther.css');
export default class PopUpInCome extends React.Component {
    constructor(props) {
        super(props);
        this.SearchInput = React.createRef();
        this.state = {
            CText1: "1",
            CText2: "2",
            rows: [],
        }
    }
    componentDidMount() {
        let col = [];
        for (let i = 0; i < 15; i++) {
            col[i] = {
                number: i + 1,
                code: "",
                text: "",
                lasttype: ""
            }
        }
        this.setState({ rows: col });
        setInterval(() => {
            if (this.state.CText1 === this.state.CText2 && this.state.CText1 !== '') {
                this.onWriteRow(this.state.CText1);
                this.setState({ CText2: "" });
            }
        }, 20);
    }
    onKeyUp = (data) => {
        if (data.key === "Enter") {
            var value = data.target.value;
            this.setState({ CText1: value });
            this.setState({ CText2: value });
        }
    }
    onClickSearch = (e) => {
        var value = this.SearchInput.current.value;
        this.setState({ CText1: value });
        this.setState({ CText2: value });
    }
    onWriteRow = (data) => {
        var url = "CSPRODUCT/Name?name=" + data + "&user=" + localStorage.getItem("Username");
        GetCorService(url).then(res => {
            if (res.data) {
                var data = res.data;
                let col = [];
                for (var i = 0; i <= data.length - 1; i++) {
                    col[i] = {
                        number: i + 1,
                        code: data[i].CODE,
                        text: data[i].NAMETH,
                        salelastprice: data[i].SALELASTPRICE,
                        unitname: data[i].STOCKUNIT,
                        STOCKQTY: data[i].STOCKQTY,
                        STOCKQTYWH: data[i].STOCKQTYWH,
                        NETSTOCK: data[i].NETSTOCK,
                        GIWAREHOUSE: data[i].GIWAREHOUSE,
                        LOCATION: data[i].LOCATION,
                    }
                }
                this.setState({ rows: col });
            }
        });
    }
    onSelectRow = (data) => {
        if (data.code) {
            this.props.Get_PopUpItem(data);
            this.props.closePopup();
        }
    }

    render() {
        return (
            <div className='popup' >
                <div className='popup_inner'>
                    <div className="PopUpOtherDivH" align="left">
                        <div className="PopUpOtherDivH1"> <i className="fas fa-search"> ค้นหาสินค้า </i> </div>
                        <div className="PopUpOtherDivH2" onClick={this.props.closePopup}><i className="fas fa-times"></i></div>
                    </div>
                    <div className="panel-body DivTable" align="right">
                        <div className="col-md-2">
                            <image src={mainLogo} width="100%" />
                        </div>
                        <div className="col-md-6" align="left">
                            <div className="input-group" style={{ padding: '5px', marginTop: '10px' }}>
                                <span style={{ padding: '5px' }}> ค้นหาสินค้า </span>
                            </div>
                            <div className="input-group" style={{ padding: '5px', width: "100%" }}>
                                <input type="text" className="form-control" placeholder="กรอกคำค้นหา" ref={this.SearchInput} onKeyUp={this.onKeyUp} />
                                <span className="input-group-addon txt-img icon"><i className="fas fa-search" onClick={this.onClickSearch}></i></span>
                            </div>
                        </div>

                        <div className="DivTable">
                            <BootstrapTable
                                data={this.state.rows}
                                options={
                                    { onRowClick: this.onSelectRow }
                                }
                                height='380'
                                hover condensed>
                                <TableHeaderColumn columnClassName="columnAll columnNumber" className="columnNumber" dataAlign="center" width="35" dataField='number' isKey> </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="200" dataField='code' dataSort> รหัส </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="200" dataField='text' dataSort> ชื่อ/คำอธิบาย </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="70" dataField='GIWAREHOUSE' dataSort> คลัง </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="70" dataField='LOCATION' dataSort> ที่เก็บ </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="right" width="100" dataField='STOCKQTY' dataSort> คงเหลือรวม </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="right" width="70" dataField='NETSTOCK' dataSort> สุทธิ </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="right" width="125" dataField='salelastprice' dataSort> ราคาขายล่าสุด </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataAlign="center" width="45" dataField='unitname' dataSort> หน่วย </TableHeaderColumn>
                            </BootstrapTable>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export class PopUpCSEXPENSE extends React.Component {
    constructor(props) {
        super(props);
        this.Search = React.createRef();
        this.state = {
            CText1: "1",
            CText2: "2",
            rows: [],
        }
    }
    componentDidMount() {
        this.onWriteRow('');
    }
    onWriteRow = (data) => {
        var url = "CSOTHERINCOME/Searchincome?Code=" + data;
        GetCorService(url).then(res => {
            //     var Url = "http://Localhost:8080/Searchincome?Code=" + data;
            //     INSCorServicePostTest(Url).then(res => {
            var data = res.data;
            let col = [];
            try {
                for (var i = 0; i <= data.length - 1; i++) {
                    col[i] = {
                        number: i + 1,
                        code: data[i].CODE,
                        text: data[i].MYNAMETH,
                        salelastprice: data[i].SALELASTPRICE,
                        unitname: data[i].STOCKUNIT,
                        STOCKQTY: data[i].STOCKQTY,
                        STOCKQTYWH: data[i].STOCKQTYWH,
                        NETSTOCK: data[i].NETSTOCK,
                        GIWAREHOUSE: data[i].GIWAREHOUSE,

                    }
                }
            } catch (error) {
                console.log(error);
            }
            this.setState({ rows: col });
        });
    }
    Get_Expcode = (e) => {
        if (e.key === "Enter") {
            this.onWriteRow(e.target.value);
        }
        if (e === "Click") {
            this.onWriteRow(this.Search.current.value);
        }
    }
    onSelectRow = (data) => {
        if (data.code) {
            this.props.Get_PopUpCSEXPENSE(data);
            this.props.closePopup();
        } else {
            //    this.props.AlertPopup('Warning','ไม่พบข้อมูล')
        }
    }
    render() {
        return (
            <div className='popup' >
                <div className='popup_inner'>
                    {this.props.Data}
                    <div className="PopUpOtherDivH" align="left">
                        <div className="PopUpOtherDivH1"><i className="fas fa-search" > ค้นหารายได้อื่นๆ-Income </i></div>
                        <div className="PopUpOtherDivH2"><i className="fas fa-times" onClick={this.props.closePopup}></i></div>
                    </div>
                    <div className="panel-body divTable" align="left">
                        <div className="input-group width-grop" >
                            <input id="id1" type="text" className="form-control" ref={this.Search} onKeyPress={this.Get_Expcode.bind(null)} />
                            <span id="iconsearch" className="input-group-addon icon" onClick={this.Get_Expcode.bind(null, "Click")}><i className="fas fa-search"></i></span>
                        </div>
                        <div className="DivTable">
                            <BootstrapTable
                                data={this.state.rows}
                                options={{
                                    onRowClick: this.onSelectRow,
                                    noDataText: "ไม่พบข้อมูลที่ค้นหา",
                                }}
                                height="750"
                                hover condensed>
                                <TableHeaderColumn columnClassName="columnAll columnID" className="columnNumber" dataAlign="center" width="35" dataField='number' isKey> </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="150" dataField='code'> รหัส </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" dataField='text' > ชื่อ/คำอธิบาย </TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                    </div>
                </div>
            </div>
        );

    }


}